import { render, staticRenderFns } from "./ModalFormOrderService.vue?vue&type=template&id=568e9bb1"
import script from "./ModalFormOrderService.vue?vue&type=script&lang=js"
export * from "./ModalFormOrderService.vue?vue&type=script&lang=js"
import style0 from "./ModalFormOrderService.vue?vue&type=style&index=0&id=568e9bb1&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568e9bb1')) {
      api.createRecord('568e9bb1', component.options)
    } else {
      api.reload('568e9bb1', component.options)
    }
    module.hot.accept("./ModalFormOrderService.vue?vue&type=template&id=568e9bb1", function () {
      api.rerender('568e9bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalFormOrderService.vue"
export default component.exports